module.exports = __webpack_public_path__ + "static/SP-240-v-ac-2-pole-relay-companion-module-c23bc33151ac4554934ac300f6d8af93.pdf";